/** @format */

import $http from '../../shared/http';

export default {
  namespaced: true,
  state: () => {
    return {
      followUpReasonsForSelect: null,
      followUpPersonTypesForSelect: null,
      followUpContactTypesForSelect: null,
      followupData: null,
    };
  },
  getters: {
    getFollowUpReasonsForSelect: (state) => state.followUpReasonsForSelect,
    getFollowUpPersonTypesForSelect: (state) => state.followUpPersonTypesForSelect,
    getFollowUpContactTypesForSelect: (state) => state.followUpContactTypesForSelect,
    getCurrentFollowUpData: (state) => state.followupData,
  },
  mutations: {
    setFollowUpReasonsForSelect: (state, payload) => (state.followUpReasonsForSelect = payload),
    setFollowUpPersonTypesForSelect: (state, payload) =>
      (state.followUpPersonTypesForSelect = payload),
    setFollowUpContactTypesForSelect: (state, payload) =>
      (state.followUpContactTypesForSelect = payload),
    setCurrentFollowUpData: (state, data) => {
      state.followupData = data;
    },
  },
  actions: {
    async LOAD_FOLLOW_UP_REASONS_FOR_SELECT({ commit }, { churchId }) {
      return $http('v2')
        .get(`organisations/${churchId}/follow_up_reasons`)
        .then((response) => {
          commit('setFollowUpReasonsForSelect', response.data.data);
          return response;
        });
    },
    async LOAD_FOLLOW_UP_CONTACT_TYPES_FOR_SELECT({ commit }, { churchId }) {
      return $http('v2')
        .get(`organisations/${churchId}/follow_up_contact_types`)
        .then((response) => {
          commit('setFollowUpContactTypesForSelect', response.data.data);
          return response;
        });
    },
    async LOAD_FOLLOW_UP_PERSON_TYPES_FOR_SELECT({ commit }, { churchId }) {
      return $http('v2')
        .get(`organisations/${churchId}/follow_up_person_types`)
        .then((response) => {
          commit('setFollowUpPersonTypesForSelect', response.data.data);
          return response;
        });
    },
    async LOAD_FOLLOW_UP_DATA({ commit }, followup_id) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/follow-ups/${followup_id}`)
          .then(async (response) => {
            commit('setCurrentFollowUpData', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async CREATE_FOLLOW_UP_ACTION(ctx, form) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post(`/follow-ups`, form, { headers: { 'X-Is-Notifiable': 'On' } })
          .then(async (response) => {
            return resolve(response.data.data);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
    async CREATE_FOLLOW_UP_LOG_ACTION(ctx, { form, followUpId }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post(`/follow-ups/${followUpId}/logs`, form, { headers: { 'X-Is-Notifiable': 'On' } })
          .then(async (response) => {
            return resolve(response.data.data);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
    async EDIT_FOLLOW_UP_ACTION(ctx, { id, form }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .put(`/follow-ups/${id}`, form, { headers: { 'X-Is-Notifiable': 'On' } })
          .then(async (response) => {
            return resolve(response.data.data);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
    async DELETE_FOLLOW_UP_ACTION(ctx, { id }) {
      return $http()
        .delete(`/follow-ups/${id}`, { notifiable: true })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    async EDIT_FOLLOW_UP_LOG_ACTION(ctx, { id, message, contact_time }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .put(
            `/follow-up-logs/${id}`,
            { message, contact_time },
            { headers: { 'X-Is-Notifiable': 'On' } }
          )
          .then(async (response) => {
            return resolve(response.data.data);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
  },
};
